import React from 'react';
import { Box, Button, List, ListItem } from '@mui/material';
import { ChevronRightIcon } from './icons';

export function NavigationMenuList({
  children,
  label,
}: {
  children: React.ReactNode;
  label: string;
}) {
  return (
    <List
      aria-label={label}
      sx={{
        px: { xs: 2, sm: 3 },
        py: 2,
        display: 'grid',
        gap: 1,
        overflowY: 'auto',
        maxHeight: 'calc(100dvh - 88px)',
      }}
    >
      {children}
    </List>
  );
}

export function NavigationMenuRow({
  icon,
  label,
  description,
  onClick,
  tone = 'default',
  showChevron = true,
}: {
  icon: React.ReactNode;
  label: string;
  description?: string;
  onClick: () => void;
  tone?: 'default' | 'danger';
  showChevron?: boolean;
}) {
  return (
    <ListItem disablePadding>
      <Button
        fullWidth
        color={tone === 'danger' ? 'error' : 'primary'}
        startIcon={icon}
        aria-label={label}
        onClick={onClick}
        sx={{ justifyContent: 'flex-start', textAlign: 'left' }}
      >
        <Box component="span" sx={{ flex: 1, minWidth: 0 }}>
          {label}
          {description && (
            <Box
              component="span"
              sx={{
                display: 'block',
                typography: 'body2',
                color: 'text.secondary',
                overflowWrap: 'anywhere',
              }}
            >
              {description}
            </Box>
          )}
        </Box>
        {showChevron && (
          <ChevronRightIcon
            aria-hidden="true"
            sx={{ ml: 1, color: 'text.secondary', fontSize: 20, flexShrink: 0 }}
          />
        )}
      </Button>
    </ListItem>
  );
}
